"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _getUserAccessToken = _interopRequireDefault(require("../tokens/getUserAccessToken"));

var _settingsResolver = _interopRequireDefault(require("../settingsResolver"));

var getUserInfo = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(baseSettings) {
    var token, settings;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            token = (0, _getUserAccessToken.default)();

            if (token) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", Promise.reject(new Error('No access token available')));

          case 3:
            _context.next = 5;
            return (0, _settingsResolver.default)(baseSettings);

          case 5:
            settings = _context.sent;
            return _context.abrupt("return", fetch(settings.userInfo, {
              mode: 'cors',
              headers: {
                Authorization: "Bearer ".concat(token)
              }
            }).then(function (data) {
              if (!data.ok) {
                throw new Error(data.statusText);
              }

              return data.json();
            }).then(function (response) {
              return response;
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getUserInfo(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _default = getUserInfo;
exports.default = _default;